<!-- Mirrors DocumentsComponent's preview modal (isPreviewOpen / iframe-wrapper /
     iframe-spinner-overlay) so the invoice viewing experience matches the
     existing document viewing experience, without modifying the Documents
     module. See the class-level comment in invoice-pdf-viewer.component.ts. -->
<div *ngIf="isOpen" class="preview-modal">
  <div class="preview-content">
    <div class="preview-header">
      <h2>{{ title }}</h2>
      <button mat-icon-button (click)="close()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="iframe-wrapper">
      <div *ngIf="isLoading" class="iframe-spinner-overlay">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading invoice preview...</p>
      </div>

      <ng-container *ngIf="!isLoading && previewUrl">
        <div class="preview-body">
          <iframe width="100%" height="100%" [src]="previewUrl" frameborder="0"></iframe>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading && !previewUrl">
        <div class="no-preview">
          <img class="docmat" src="assets/images/docs.png" alt="document icon">
          <p>Invoice preview not available</p>
        </div>
      </ng-container>
    </div>
  </div>
</div>